// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import authService from '../services/authService';
import Login from '../components/Login.vue';
import GameTypeSelection from '../components/GameTypeSelection.vue';
import TeamSetup from '../components/TeamSetup.vue';
import Game from '../components/Game.vue';
import GameSelection from "@/components/GameSelection.vue";
import Settings from "@/components/Settings.vue";
import Player from "@/components/Player.vue";
import Heatmap from "@/components/Heatmap.vue";
import PlayerDetail from "@/components/PlayerDetail.vue";
import Info from '@/components/Info.vue';

// Definierte Routen
const routes = [
  { path: '/', name: 'Home', component: Login }, // Login-Seite (immer zugänglich)
  {
    path: '/main',
    name: 'GameType',
    component: GameTypeSelection,
    meta: { requiresAuth: true }, // Diese Route erfordert die Authentifizierung
  },
  {
    path: '/team',
    name: 'TeamSetup',
    component: TeamSetup,
    meta: { requiresAuth: true }, // Diese Route erfordert die Authentifizierung
  },
  {
    path: '/game',
    name: 'Game',
    component: Game,
    meta: { requiresAuth: true }, // Diese Route erfordert die Authentifizierung
  },
  {
    path: '/gameselection',
    name: 'Gameselection',
    component: GameSelection,
    meta: { requiresAuth: true }, // Diese Route erfordert die Authentifizierung
  },
  {
    path: '/settings',
    name: 'GameSettings',
    component: Settings,
    meta: { requiresAuth: true }, // Diese Route erfordert die Authentifizierung
  },
  {
    path: '/players',
    name: 'Players',
    component: Player,
    meta: { requiresAuth: true }, // Diese Route erfordert die Authentifizierung
  },
  {
    path: '/heat',
    name: 'Heatmap',
    component: Heatmap,
    meta: { requiresAuth: true }, // Diese Route erfordert die Authentifizierung
  },
  {
    path: "/player/:playerId",
    name: "PlayerDetail",
    component: PlayerDetail,
    props: true, // Damit playerId direkt als Prop übergeben wird
  },
  {
    path: '/info',
    name: 'Info',
    component: Info,
    meta: { requiresAuth: true }, // Diese Route erfordert die Authentifizierung
  },
];

// Router erstellen
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation Guard: Prüft vor jedem Routenwechsel
router.beforeEach((to, from, next) => {
  if (to.name === 'Home' && authService.isAuthenticated()) {
    // Wenn der Benutzer zur Login-Seite navigiert und eingeloggt ist
    return next({ name: 'GameType' }); // Weiterleitung zur Hauptseite
  }

  if (to.meta.requiresAuth && !authService.isAuthenticated()) {
    // Routen mit Auth-Anforderung und Benutzer ist nicht eingeloggt
    return next({ name: 'Home' }); // Weiterleitung zur Login-Seite
  }
  next();

});

export default router;